/**
 * Integrity timeline time formatting (recruiter report).
 *
 * `ms` is the offset from the start of the interview / monitoring, as computed by the
 * backend (IntegritySummaryBuilder: interview-relative time, else server receive time
 * relative to the same origin). A missing time is shown as "Time unavailable" and is
 * never rendered as 00:00.
 */
export const TIME_UNAVAILABLE = 'Time unavailable';

export function formatElapsed(ms) {
  if (ms === null || ms === undefined || ms === '' || Number.isNaN(Number(ms)) || Number(ms) < 0) {
    return TIME_UNAVAILABLE;
  }
  const total = Math.floor(Number(ms) / 1000);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');
  return hours > 0 ? `${hours}:${mm}:${ss}` : `${mm}:${ss}`;
}

/** "Q3" for an answered question, "Intro" for the warm-up (0), nothing when unknown. */
export function questionLabel(index) {
  if (index === null || index === undefined) return null;
  return Number(index) === 0 ? 'Intro' : `Q${index}`;
}
